const config = {
  API_ENDPOINT:  'https://floating-ocean-52183.herokuapp.com/api',
  TOKEN_KEY: 'motiforge-client-auth-token',
}
export default config
